import React from "react";
import { Link } from "react-router-dom";
import { currency } from "@/lib/api";
import { useLead } from "@/context/LeadDialog";
import { ArrowRight } from "lucide-react";

export function ProductCard({ product }) {
  const { openLead } = useLead();
  const off = product.mrp > product.price ? Math.round(((product.mrp - product.price) / product.mrp) * 100) : 0;
  return (
    <div data-testid={`product-card-${product.slug}`} className="group flex flex-col">
      <Link to={`/product/${product.slug}`} className="block">
        <div className="product-media aspect-[4/5]">
          <img src={product.images?.[0]} alt={product.name} className="w-full h-full object-cover" />
        </div>
      </Link>
      <div className="mt-4 flex-1">
        <div className="eyebrow" style={{ color: "var(--asure-deep)" }}>{product.category.replace(/-/g, ' ')}</div>
        <Link to={`/product/${product.slug}`}><h3 className="font-display text-xl md:text-2xl mt-1 leading-tight text-asure-text hover:text-asure-forest transition-colors">{product.name}</h3></Link>
        <p className="text-sm text-asure-text2 mt-1 line-clamp-2">{product.short_description}</p>
      </div>
      <div className="mt-3 flex items-baseline gap-2">
        <span className="text-lg font-semibold text-asure-forest">{currency(product.price)}</span>
        {product.mrp > product.price && (
          <>
            <span className="text-sm line-through text-asure-text2/60">{currency(product.mrp)}</span>
            <span className="text-xs font-bold text-asure-orange">{off}% off</span>
          </>
        )}
      </div>
      <button onClick={() => openLead(product.name)} data-testid={`enquire-${product.slug}`}
        className="mt-4 inline-flex items-center justify-center gap-2 py-2.5 px-4 rounded-full bg-asure-forest text-white text-sm font-semibold hover:bg-asure-deep transition-colors">
        I'm Interested <ArrowRight size={14} />
      </button>
    </div>
  );
}

export function SectionHeading({ eyebrow, title, subtitle, align = "left" }) {
  return (
    <div className={`${align === "center" ? "text-center max-w-2xl mx-auto" : "max-w-2xl"}`}>
      {eyebrow && <div className="eyebrow">{eyebrow}</div>}
      <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.02] mt-4 tracking-tight text-asure-text">{title}</h2>
      {subtitle && <p className="mt-4 text-base md:text-lg text-asure-text2 leading-relaxed">{subtitle}</p>}
    </div>
  );
}
